/**
 * MobileCaptchaService 兼容性包装类
 * 提供旧 API 兼容的接口，内部使用新的 protobuf-ts 生成的客户端
 */
import { MobileCaptchaServiceClient } from "../../api/base/captcha/mobile_captcha.client";
import { HttpRpcTransport } from "./HttpRpcTransport";
import { HttpResponse } from "../../assets/javascripts/http";

/**
 * 递归解包装所有 StringValue 类型
 */
function unwrapResponse(obj: any): any {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => unwrapResponse(item));
  }

  const result: any = {};
  for (const key in obj) {
    const value = obj[key];
    if (value && typeof value === 'object' && 'value' in value && Object.keys(value).length === 1) {
      // 这是一个包装类型（StringValue, Int32Value 等）
      result[key] = value.value;
    } else if (value && typeof value === 'object') {
      result[key] = unwrapResponse(value);
    } else {
      result[key] = value;
    }
  }
  return result;
}

/**
 * MobileCaptchaService 包装类
 * 保持与旧代码相同的构造函数签名和方法调用方式
 */
export class MobileCaptchaService {
  private client: MobileCaptchaServiceClient;

  constructor(baseUrl: string, postFn: (url: string, headers: any, body: any) => Promise<HttpResponse>) {
    const transport = new HttpRpcTransport(baseUrl, postFn);
    this.client = new MobileCaptchaServiceClient(transport);
  }

  async generate(request: any) {
    const response = await this.client.generate(request).response;
    return unwrapResponse(response);
  }
}
